<template>
  <div class="employee-section">
    <span class="type-title">
      人员
      <i>
        (共
        <em>{{ sectionData.length }}</em> 条记录)
      </i>
      <look-more
        v-if="hideContent && activeSectionData.length > max"
        type="user"
      />
    </span>
    <div :class="{ 'data-view': true, 'view-over': !hideContent }">
      <div
        v-for="(i, n) in hideContent
          ? activeSectionData.slice(0, max)
          : activeSectionData"
        :key="n"
        class="result-item"
        target="_blank"
      >
        <div class="result-top">
          <img class="avatar" :src="i.imgs[0]" alt v-if="i.imgs.length > 0" />
          <span v-else class="avatar">{{ i.name.slice(-2) }}</span>
          <div class="result-right">
            <span
              v-high-light="{
                key: $route.params.key,
                content: i.name + '(' + i.uid + ')'
              }"
              class="name"
              >{{ i.name }}({{ i.uid }})</span
            >
            <span class="email">{{ i.mail }}</span>
          </div>
        </div>
        <span class="deptpath">{{ i.deptpath }}{{ i.postname }}</span>
      </div>
    </div>

    <el-pagination
      v-if="!hideContent"
      :total="sectionData.length"
      layout="prev, pager, next"
      :page-size="pageSize"
      @current-change="handleCurrentChange"
    ></el-pagination>
  </div>
</template>
<script>
import lookMore from "./look-more";

export default {
  name: "employee-section",
  components: { lookMore },
  props: {
    sectionData: Array,
    hideContent: {
      type: Boolean,
      default: true
    },
    max: {
      type: Number,
      default: 6
    }
  },

  watch: {
    sectionData: {
      handler: function() {
        console.log("sectionData", this.sectionData);
        this.activeSectionData = this.sectionData.slice(0, this.pageSize);
      },
      immediate: true
    }
  },

  data() {
    return {
      currentPage: 1,
      pageSize: 18,
      activeSectionData: []
    };
  },

  methods: {
    handleCurrentChange(val = 1) {
      this.currentPage = Number(val);
      // 一页10条 0-9 10-20
      const startIndex = (this.currentPage - 1) * this.pageSize, // 开始索引
        endIndex = this.currentPage * this.pageSize; // 结束的数据
      this.$set(
        this,
        "activeSectionData",
        this.sectionData.slice(startIndex, endIndex)
      );
      this.$forceUpdate();
    }
  }
};
</script>
<style lang="scss" scoped>
.employee-section {
  .data-view {
    margin-top: 20px;
    display: grid;
    grid-column-gap: 19px;
    grid-template-columns: 346px 346px 346px;
  }
  .section-title {
    color: #ffffff;
    width: 80px;
    height: 24px;
    font-size: 14px;
    line-height: 24px;
    display: inline-block;
    text-align: center;
  }

  .record-length {
    color: rgba(143, 149, 172, 1);
    font-size: 12px;
    font-weight: normal;
    margin-left: 6px;
  }

  .result-item {
    width: 346px;
    height: 160px;
    display: flex;
    flex-direction: column;
    padding: 20px;
    box-sizing: border-box;
    font-size: 12px;
    border-radius: 8px;
    color: #666666;
    background-color: rgba(255, 255, 255, 1);
    border: 1px solid rgba(237, 237, 237, 1);
    .result-right {
      flex: 1;
    }
    .result-top {
      display: flex;
      align-items: center;
    }
    .avatar {
      width: 60px;
      height: 60px;
      border-radius: 30px;
      background: #4272ab;
      color: #ffffff;
      line-height: 60px;
      display: block;
      text-align: center;
      margin-right: 21px;
    }
    .deptpath {
      line-height: 20px;
      font-size: 14px;
      margin-top: 20px;
      display: inline-block;
      word-break: break-all;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .email {
      width: 100%;
      font-size: 14px;
      word-break: break-all;
      display: inline-block;

      margin-top: 8px;
    }
    span + span {
      margin-bottom: 10px;
    }

    .name {
      color: #333333;
      font-size: 16px;
    }
  }
}
</style>
